import { useState } from "react";
import ThumbnailBanner from "./ThumbnailBanner";
import SectionHeading from "../SectionHeading";

const videoData = {
  link: "https://www.youtube.com/watch?v=0DWaAoSYt4o",
  banner: "/assets/pet-tag/video-thumbnail.png",
};

const PetTagVideo = ({ videoDetails = videoData }) => {
  const [isPlaying, setPlaying] = useState(false);
  const videoUrl = videoDetails.link;

  let videoId;

  if (videoUrl.includes("youtu.be")) {
    const startIndex = videoUrl.indexOf(".be/") + 4;
    videoId = videoUrl.slice(startIndex);
  } else {
    let endIndex = videoUrl.length;
    if (videoUrl.includes("&")) endIndex = videoUrl.indexOf("&");
    videoId = videoUrl.slice(videoUrl.indexOf("=") + 1, endIndex);
  }

  return (
    <div className="max-w-[23.875rem] md:max-w-[32rem] lg:max-w-[42rem] xl:max-w-[54.125rem] aspect-video mx-auto pb-[2.5rem] lg:pb-[5rem] px-[0.5rem] min-[400px]:px-0">
      <SectionHeading
        title="Smart NFC Pet Tag Overview"
        className="mb-[3.125rem]"
      />

      {isPlaying ? (
        <iframe
          allowFullScreen
          title="Smart NFC Pet Tag Overview"
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1&controls=0&rel=0`}
          className="aspect-video w-full rounded-[0.5rem] md:rounded-[0.875rem]"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        />
      ) : (
        <ThumbnailBanner
          rounded
          imageAltText="How Does It Work?"
          iconURL="/assets/icons/pet-tag-video-play.svg"
          imageURL={videoDetails?.banner}
          iconClickHandler={() => setPlaying(true)}
        />
      )}
    </div>
  );
};

export default PetTagVideo;
